<template>
  <div id="employee" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <!-- Conceptos medicos -->
      <header-v2 :title="'Conceptos Médicos'"/>
      <!-- end -->
      <!-- Buscador -->
      <div class="row mt-5">
        <div class="col-10 p-2 mx-auto mt-3">
          <div class="col-6 p-0 d-flex align-items-center">
            <img class="centerImg1 mr-2" src="@/assets/images/icons/user-2-line.svg" width="15px">
            <h3 class="m-0">Datos del trabajador</h3>
          </div>
          <v-select class="mt-3 col-6 p-0 search-box"
                    label="name_cc_sharp_id"
                    :options="employeesBySearch"
                    v-model="employee"
                    @search="filterEmployees"
                    @input="actGetEmployeeInfo(employee.id)">
            <template slot="no-options">
              No se encontro ningun trabajador
            </template>
          </v-select>
        </div>
      </div>
      <!-- end -->
      <template v-if="loading" >
        <loader-version2 />
      </template>
      <template v-else>
        <div class="col-10 p-2 mx-auto">
          <!-- Si existe el empleado se muestra los componentes-->
          <template v-if="employee.id">
            <!-- <WorkerInfo :dataUser="employeeInfo.data.employee" /> -->
            <worker-info-v2 :prop-user="employeeInfo.data.employee" />

            <b-card no-body class="mt-5 toggle-tab card_scroll overflow-hidden" ref="cardScroll">
              <!-- Lista de opciones -->
              <b-nav pills card-header slot="header" v-b-scrollspy:nav-scroller>
                <b-nav-item href="#nav-labor-history" @click="scrollIntoView">Histórico laboral</b-nav-item>
                <b-nav-item href="#mdo" @click="scrollIntoView">Condiciones de salud</b-nav-item>
                <b-nav-item href="#nav-health-factors" @click="scrollIntoView">Factores de salud</b-nav-item>
                <b-nav-item href="#nav-absenteeism" @click="scrollIntoView">Ausentismos</b-nav-item>
                <b-nav-item href="#pi0" @click="scrollIntoView">Recomendaciones</b-nav-item>
                <b-nav-item href="#test" @click="scrollIntoView">Accidentes laborales</b-nav-item>
              </b-nav>
              <!-- end -->

              <b-card-body
                  id="nav-scroller"
                  ref="content"
                  class="mt-5"
                  style="position:static; height:900px; overflow-y:scroll;">

                <!-- Factores de Salud -->
                <template class="mt-5 mb-5">
                  <health-factors id="nav-health-factors" :dataUser="employeeInfo.data.health_factors" />
                </template>
                <!-- end -->

                <hr>

                <!-- Ausentismos -->
                <template class="mt-5 mb-5">
                  <absenteeism id="nav-absenteeism"
                               :dataUser="employeeInfo.data.employee"
                               :userAbs="employeeInfo.data.absenteeism"
                               :totalAbsenteeism="employeeInfo.data.total_absenteeism"
                               :filterButton="false"
                               :HistoryButtonAbs="true"
                               stadistics="resume"
                               @change:reload-data="mount"
                               :pagination="false"/>
                </template>
                <!-- end -->

                <hr>
              </b-card-body>

            </b-card>

            <!-- <ComingSoon/> -->
          </template>
          <!-- end -->
          <template v-else>
            <div class="row col-12">
              <div class="alert alert-dark alert-sm alert-info-custom info-alert" role="alert">
                <h5>
                                <span class="icon icon-info text-primary mr-2 mt-2"
                                      style="margin-left: 10px;
                                position: relative;
                                top: 2px !important;"> </span>
                  Empecemos con la búsqueda de un trabajador
                </h5>
              </div>
              <div class="row col-12 d-flex justify-content-left">
                <img
                    src="@/assets/images/platformSettings/ht_img_tablet.svg"
                    class="col-5 mt-1"
                    style="height: 200px; width: 200px;">
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState,mapActions } from "vuex";
/* import WorkerInfo from '../../components/healthTracker/workerInfo.vue' */
import MainBarMenuV2 from "../../components/layouts/MainBarMenuV2.vue";
import HeadingUser from "../../components/user/HeadingUser.vue";
import Absenteeism from '../../components/healthTracker/absenteeism.vue'
/* import ComingSoon from "../../components/healthTracker/comingSoon.vue" */
import HealthFactors from './healthFactorsResume.vue'
export default {
  name: "employee",
  components: {
    MainBarMenuV2,
    HeadingUser,
    /* WorkerInfo, */
    WorkerInfoV2: () => import('../../components/healthTracker/workerInfo/WorkerInfoV2.vue'),
    Absenteeism,
    /* ComingSoon, */
    HealthFactors,
    HeaderV2: () => import('../../components/common/header/HeaderV2.vue')
  },
  data() {
    return {
      employee: {
        value: null,
        name_cc_sharp_id: 'Búsqueda por nombre o cédula'
      },
      runtime:''
    }
  },
  computed: {
    ...mapState("modOhAnalyst", [
      "loading",
      "loading2",
      "error",
      "message",
      "employeeInfo",
      "employeesBySearch",
      "previousUser"
    ]),
  },
  beforeMount() {
    let data = { search:'' }
    this.actGetEmployeesBySearch(data)
    if(localStorage.getItem('employee')){
      this.actGetEmployeeInfoLocal()
      this.employee = this.employeeInfo.data.employee
    }
  },
  created() {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    ...mapActions("modOhAnalyst", [
      'actGetEmployeeInfo',
      'actGetEmployeesBySearch',
      'actGetEmployeeInfoLocal'
    ]),
    async mount()
    {
        location.reload()
    }
    ,onScroll () {
      const element = this.$refs.cardScroll
      const elementTop = element.getBoundingClientRect().top
      const elementChangeStyle = element.getElementsByClassName('card-header')[0].style
      const elementClass = element.getElementsByClassName('card-header')[0].classList
      if (window.scrollY >= (elementTop))  {
        this.applyStyles(elementChangeStyle, {
          // position: 'fixed',
          // top: '0',
          // 'z-index': 10
        })
        elementClass.remove('col-12')
        elementClass.add('col-9')
      } else {
        this.applyStyles(elementChangeStyle, {
          position: 'static'
        })
        elementClass.remove('col-9')
        elementClass.add('col-12')
      }
    },
    filterEmployees(search,loading){
      loading(true)
      let data = {
        search: search,
      }
      this.actGetEmployeesBySearch(data).then(() => loading(false))
    },
    scrollIntoView(event) {
      event.preventDefault()
      const href = event.target.getAttribute('href')
      const el = href ? document.querySelector(href) : null
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop
      }
    }
  }
}
</script>

<style lang="scss">
#employee {
  tbody tr td {
    padding: 10px 2px;
  }
  .choose{
    color:#454545;
    font-family: Open Sans;
    font-style: italic;
    font-weight: normal;
    font-size: 13px;
  }
  .vs__dropdown-toggle{
    font-size: 15px;
    height: 50px;
    input{
      margin-top:0px
    }
    border-radius: 100px;
    flex-grow: 0;
    margin: 0px 1px;
    padding: 5px 10px;
  }
  .vs__actions {
    svg {
      fill: #7A7CFF;
    }
  }
  .vs__open-indicator {
    display: none;
  }
  .info-alert{
    padding: 0px;
    //margin-left:20px;
    margin-top:20px;
    width: 383px;
    height: 36px;
    position: relative !important;
    background: #E6F7FF !important;
    border: 1px solid #0075FF;
    box-sizing: border-box;
    border-radius: 4px;
    span {
      width: 383px;
      height: 36px;
      font: normal normal 400 16px/28px 'Ubuntu';
      color: #263238;
    }
  }
  .card-body {
    padding: 0;
  }
  .card_scroll {
    border: 0 !important;
    border-radius: 0;
    box-shadow: none !important;
  }
  .card_scroll .card-header {
    padding: 0;
    margin-bottom: 0;
    background-color: transparent !important;
    border-bottom: 0;
    display: block;
    text-align: center;
    // border-radius: 48px;
  }
  .toggle-tab {
    ul {
      padding: 4px;
      /* CTA/00 */

      background: #FFFFFF;
      /* CTA/01 */

      border: 1px solid #C9CAFF;
      box-sizing: border-box;
      border-radius: 48px;

      /* Inside auto layout */

      flex: none;
      order: 0;
      flex-grow: 0;
      margin: 0.5px 0.5px;
      width: max-content;
    }
    li {
      padding: 3px 12px;
      a {
        font: normal normal 300 14px/22px 'Ubuntu';
        color: #000000;
        transition: all 0.3s ease;
      }
      a:hover, a.active {
        bottom: 0%;
        border-radius: 100px;
        flex-grow: 0;
        color: #FFFFFF !important;
        background-color: #5D5FEF;
      }
    }
  }
}
</style>